import React from 'react';
import { View, colors } from '@fairygodboss/ui';
import { Play } from './Play';
import { Slider } from './Slider';
import { Time } from './Time';
import { Volume } from './Volume';
import { Options } from './Options';
import { PlayText } from './PlayText';

export const Player = () => {
    return (
        <View
            width="100%"
            height="64px"
            backgroundColor={colors.secondary[70]}
            display="flex"
            justifyContent="center"
            marginTop="-3px"
        >
            <PlayText />
            <View
                display="flex"
                alignItems="center"
                width="346px"
                position="relative"
            >
                <Play />
                <Time />
                <Slider />
                <Volume />
                <Options />
            </View>
        </View>
    );
};
